// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { create } from "./operations.js";
export { VaultCertificatesCreateOptionalParams } from "./options.js";
